import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../../../shared/shared.module';
import { MaterialModule } from '../../../../../shared/material.module';
import { ManualAddComponent } from './manual-add.component';
import { MatTableModule } from '@angular/material/table';
import { StaffTableModule } from '../../../shared/staff-table/staff-table.module';
import { IConfig, NgxMaskModule } from 'ngx-mask';
import { CustomAutocompleteModule } from 'src/app/shared/componets/custom-autocomplete/custom-autocomplete.module';

export let options: Partial<IConfig> | (() => Partial<IConfig>) = {};



@NgModule({
  declarations: [
    ManualAddComponent
  ],
  exports: [
    ManualAddComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    MatTableModule,
    StaffTableModule,
    NgxMaskModule.forRoot(options),
    CustomAutocompleteModule
  ]
})
export class ManualAddModule { }
